module.exports = __webpack_public_path__ + "static/media/dak-icons-about(3).70fe37a3.svg";